<template>
  <div>
    <SearchableTable
      :panel-header="'Gruppen'"
      :panel-route="'AddGroup'"
      :show-search-bar="true"
      :table-data="groupArrayFiltered"
      :table-meta-data="tableMetaData"
      :query-string="'setGroupSearchQuery'"
      :initial-search-query="groupSearchQuery"
      :row-click="triggerView"
      :default-sort="['attributes.group_name', 'asc']"
    />
  </div>
</template>

<script>
/**
 * This file shows all currently stored groups and allows adding and viewing
 * groups; editing and deleting happens on the view page.
 */
import { mapGetters } from "vuex";
import SearchableTable from "../helperComponents/SearchableTable.vue";

export default {
	name: "GroupsComponent",
	components: { SearchableTable },
	data() {
		return {
			tableMetaData: [
				{ "id": 0, "type": "string", "label": "Gruppenname", "field": "group_name", "sortField": "attributes.group_name" },
				{ "id": 1, "type": "string", "label": "Email", "field": "email", "sortField": "attributes.email" }
			]
		};
	},
	computed: {
		...mapGetters({
			groupArrayFiltered: "getGroupsFiltered",
			groupSearchQuery: "getGroupSearchQuery"
		})
	},
	methods: {
		triggerView(group) {
			this.$router.push(
				{ name: "ViewGroup", params: { id: group.id, data: group } });
		}
	},
};
</script>

<style lang="scss" scoped></style>
